import { useThemeStore } from '../../stores/themeStore';
import { SunIcon } from '../../assets/CustomIcons/SunIcon';
import { MonitorIcon } from '../../assets/CustomIcons/MonitorIcon';
import { MoonIcon } from '../../assets/CustomIcons/MoonIcon';
import CustomTooltip from '../UI/Tooltip/CustomTooltip';

type ThemePreference = 'light' | 'system' | 'dark';

const options: { value: ThemePreference; label: string; icon: React.ReactNode }[] = [
  { value: 'system', label: 'System', icon: <MonitorIcon /> },
  { value: 'light', label: 'Light', icon: <SunIcon /> },
  { value: 'dark', label: 'Dark', icon: <MoonIcon /> },
];

const cycleOrder: ThemePreference[] = ['system', 'light', 'dark'];

type Props = {
  collapsed: boolean;
};

const ThemeSwitcher = ({ collapsed }: Props) => {
  const { preference, setPreference } = useThemeStore();

  if (collapsed) {
    const current = options.find((o) => o.value === preference) || options[0];
    const handleCycle = () => {
      const idx = cycleOrder.indexOf(preference);
      const next = cycleOrder[(idx + 1) % cycleOrder.length];
      setPreference(next);
    };

    return (
      <div className="flex justify-center">
        <CustomTooltip title={current.label} placement="right">
          <button
            className="flex items-center justify-center w-8 h-8 border-none rounded-md bg-transparent text-neutral-700 cursor-pointer transition-all duration-200 hover:bg-neutral-300 hover:text-neutral-900"
            onClick={handleCycle}
            aria-label={`Theme: ${current.label}`}
          >
            {current.icon}
          </button>
        </CustomTooltip>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center w-24 h-8 p-0.5 rounded-md bg-neutral-300">
        {options.map((opt) => (
          <CustomTooltip key={opt.value} title={opt.label}>
            <button
              className={`flex-1 flex items-center justify-center h-full border border-solid rounded p-0 cursor-pointer transition-all duration-200 ${
                preference === opt.value
                  ? 'bg-brand-white border-neutral-300 shadow-sm text-neutral-900'
                  : 'bg-transparent border-transparent text-neutral-700 hover:text-neutral-900'
              }`}
              onClick={() => setPreference(opt.value)}
              aria-label={opt.label}
            >
              {opt.icon}
            </button>
          </CustomTooltip>
        ))}
      </div>
    </div>
  );
};

export default ThemeSwitcher;
